<template>
    <UnitInfo__sensors_template
        :class="[classForValue, $attrs.class]"
        :unitId="unitId"
        :icon="icon"
        :title="$t('Unit.sensors.Last message')"
        :statusClass="statusClass"
        :statusIcon="statusIcon"
        :value="value"
        :showButton="showButton"
        :buttonIcon="'document'"
        :buttonIconTitle="$t('Unit.History of recent messages')"
        @buttonFn="openLmsgsUnitHistory"
        v-if="_showByValue"
    />
    <!-- restoreUnit_Dialog popup -->
    <custom-modal v-if="modalWindows?.lmsgsUnitHistory" v-bind="modalWindows?.lmsgsUnitHistory?.props">
        <LastNMsgsOfUnitTable :unit-id="modalWindows?.lmsgsUnitHistory?.unitId || 0"/>
    </custom-modal>
</template>

<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
import UnitInfo__sensors_template from "@/components/units/sensors/UnitInfo__sensors_template.vue"
import LastNMsgsOfUnitTable from "@/components/units/tables/LastNMsgsOfUnitTable.vue";
import {formatTimeAgo} from "@/lib/lib";

export default {
    name: "UnitInfo__sensors_last_message",
    inheritAttrs: false,
    extends: UnitInfo__sensors_default,
    props: {
        showButton: {
            type: Boolean,
            default: () => true,
        },
    },
    components:{
        UnitInfo__sensors_template,
        LastNMsgsOfUnitTable,
    },
    data() {
        return {
            modalWindows: {}
        }
    },
    computed:{
        value() {
            let timeAgo = this.unitLmsgTimeAgo
            if (!timeAgo && timeAgo !== 0) {
                return '';
            }
            let sign = ''
            if (timeAgo < 0) {
                sign = '-'
                timeAgo *= -1
            }
            //return timeAgo
            let time = formatTimeAgo(timeAgo)

            return time ? sign + this.$t('{time} ago', {time}) : ''
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__massage' : false
        }
    },
    methods:{
        modalClose() {
            this.modalWindows = {}
        },
        openLmsgsUnitHistory() {
            this.modalWindows = {
                'lmsgsUnitHistory': {
                    unitId: this.unitId,
                    props: {
                        title: this.unit?.name + ' - ' + this.$t('Unit.History of recent messages'),
                        modalClass: 'modal-800 modal_lmsg-history',
                        btnOkClass: 'button_theme_gradient',
                        btnCanselClass: 'button_theme_neutral',
                        btnOkText: this.$t('buttons.Refresh'),
                        buttons: [
                            {id: 'ok', fn: () => {
                                    this.modalWindows = {};
                                    this.$nextTick().then(() => {
                                        this.openLmsgsUnitHistory()
                                    })

                                }},
                            {id: 'cancel', fn: () => this.modalClose()},
                        ]
                    }
                }
            }
        },
    },
}
</script>

<style lang="scss">
.modal_lmsg-history {
    .modal__title {
        justify-content: center !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;
        font-size: 18px !important;
    }
    .modal__content {
        min-height: 260px !important;
        max-height: 65vh !important;
        overflow-y: auto !important;
        padding: 0 !important;
    }
    .modal__action {
        flex-direction: row-reverse !important;
        justify-content: space-between !important;
        height: auto !important;
        button {
            width: auto !important;
            min-width: 120px !important;
            padding: 0 1.5rem !important;
        }
        .modal-ok-btn { margin-right: 0 !important; }
    }
    .lmsg-history-time-ago {
        padding: 16px 24px 8px !important;
        color: var(--color-success, #2ecc71) !important;
        font-size: 14px !important;
    }
    .lmsg-history-table {
        width: 100%;
        border-spacing: 0;
        border-collapse: collapse;
        font-size: 13px;
        th, td {
            padding: 8px 24px;
            text-align: left;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }
        th {
            font-size: 12px;
            font-weight: 600;
            opacity: 0.65;
            white-space: nowrap;
        }
        td > div:not(.text-align-center) {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 2px 16px !important;
        }
        td > div:not(.text-align-center) > div {
            font-size: 12px;
            white-space: nowrap;
        }
    }
}
</style>